import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-delete-button',
  templateUrl: './delete-button.component.html',
  styleUrls: ['./delete-button.component.scss'],
})
export class DeleteButtonComponent {
  @Input() content: any = '';
  @Input() isDisable: boolean = false;
  @Output() onClick = new EventEmitter<any>();
  @Input() icon: any = '';
  @Input() isLoading: boolean = false;

  constructor() {}

  onClickButton(event: any) {
    this.onClick.emit(event);
  }
}
